import type { ReactNode } from 'react';

import { ChartHeader, ChartHeaderTitle } from '../ChartHeader';
import { ChartCard, type ChartProps } from '../ChartRoot/Chart';
import styles from './ReportTableCard.module.css';

type ReportTableCardProps = Pick<ChartProps, 'onClick'> & {
  title?: string | null;
  children: ReactNode;
};

export const ReportTableCard = ({
  title,
  onClick,
  children,
}: ReportTableCardProps) => (
  <ChartCard onClick={onClick} isRelative variant="report-table">
    {title && (
      <ChartHeader variant="report-table">
        <ChartHeaderTitle>{title}</ChartHeaderTitle>
      </ChartHeader>
    )}
    <div
      data-testid="card-body"
      data-titled={title ? true : undefined}
      className={styles.body}
    >
      {children}
    </div>
  </ChartCard>
);
